module.exports = __webpack_public_path__ + "img/logo-short.cc1b81ea.png";